import { tr } from "../../i18n";
/**
 * LogoSfondoModal — anteprima prima/dopo della rimozione dello sfondo dal
 * logo (Andrea 2026-09-17). Lo sfondo si toglie da soli al caricamento
 * (features/common/rimuoviSfondo.ts), ma l'ultima parola e' del presidente:
 * con certi loghi il "fondo" fa parte del disegno.
 */

interface Props {
  originale: string;
  senzaSfondo: string;
  inCorso: boolean;
  onScegli: (dataUrl: string) => void;
  onClose: () => void;
}

/** Il logo su fondo scuro e su fondo chiaro: la trasparenza si vede solo cosi'. */
function Anteprima({ titolo, src }: { titolo: string; src: string }) {
  return (
    <div className="space-y-1.5">
      <div className="font-mono text-[10px] uppercase tracking-wider text-fg-muted text-center">
        {titolo}
      </div>
      <div className="grid grid-cols-2 gap-1.5">
        <div className="rounded-card bg-primary-deep border border-primary-soft/50 p-2 flex items-center justify-center">
          <img src={src} alt="" className="w-16 h-16 object-contain" />
        </div>
        <div className="rounded-card bg-white border border-primary-soft/50 p-2 flex items-center justify-center">
          <img src={src} alt="" className="w-16 h-16 object-contain" />
        </div>
      </div>
    </div>
  );
}

export function LogoSfondoModal({ originale, senzaSfondo, inCorso, onScegli, onClose }: Props) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="bg-bg-card border border-primary/30 rounded-card p-5 w-full max-w-md max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="logo-sfondo-titolo"
      >
        <h3 id="logo-sfondo-titolo" className="font-display text-xl text-accent mb-1">
          {tr("Logo senza sfondo")}
        </h3>
        <p className="text-xs text-fg-muted mb-4">
          {tr(
            tr(
              "Ho tolto lo sfondo a tinta unita, così il logo non resta in un quadrato. Controlla che non si sia portato via un pezzo dello stemma.",
            ),
          )}
        </p>
        <div className="grid grid-cols-2 gap-4">
          <Anteprima titolo="Com'è" src={originale} />
          <Anteprima titolo="Senza sfondo" src={senzaSfondo} />
        </div>
        <div className="flex gap-2 justify-end mt-5 flex-wrap">
          <button
            type="button"
            className="btn-ghost text-sm"
            disabled={inCorso}
            onClick={() => onScegli(originale)}
          >
            {tr("Tieni lo sfondo")}
          </button>
          <button
            type="button"
            className="btn-primary text-sm disabled:opacity-50"
            disabled={inCorso}
            onClick={() => onScegli(senzaSfondo)}
          >
            {inCorso ? tr("Salvo…") : tr("Usa senza sfondo")}
          </button>
        </div>
      </div>
    </div>
  );
}
